import moment from "moment";
import React, { Component } from "react";
import ModalDireccion from "../../common/scripts/modalDirecciones";
import { isCallService } from "../../common/scripts/services";
import Mensajes from "../../common/scripts/mensajes";
import ModalGeneral from "../../common/scripts/ModalGeneralComponent";

export default class ConsentimientoInformado extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      nombres: "",
      apellidos: "",
      numeroDocumento: "",
      documentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
      },
      ciudad: "",
      fechaNacimiento: "",
      showModal: false,
      visibleSelectorDocumento: false,
    };
    this.descargarCertificado = this.descargarCertificado.bind(this);
    this.getUserData = this.getUserData.bind(this);
  }

  handleInput(event) {
    let regexNombre = /[^a-z A-Z]+/g;
    let regexNumber = /\D+/g;
    let regexAlfaNum = /[^a-z A-Z0-9]+/g;
    let idDoc = this.state.documentSelected.CSIdDocumentoText;
    switch (event.target.name) {
      case "Nombres":
        let newNombre = event.target.value.replace(regexNombre, "");
        this.setState({ nombres: newNombre });
        break;
      case "Apellidos":
        let newApellido = event.target.value.replace(regexNombre, "");
        this.setState({ apellidos: newApellido });
        break;
      case "Ciudad":
        let newCiudad = event.target.value.replace(regexNombre, "");
        this.setState({ ciudad: newCiudad });
        break;
      case "NumeroDocumento":
        let numeroDocumento =
          idDoc == 5 ||
          idDoc == 6 ||
          idDoc == 8 ||
          idDoc == 10 ||
          idDoc == 11 ||
          idDoc == 12 ||
          idDoc == 13
            ? event.target.value.replace(regexAlfaNum, "")
            : event.target.value.replace(regexNumber, "");
        this.setState({ numeroDocumento: numeroDocumento });
        break;
      case "FechaNacimiento":
        this.setState({ fechaNacimiento: event.target.value });
        break;
      default:
        //console.log("none of the above");
        break;
    }
  }

  updateDocument(document) {
    this.setState({ documentSelected: document, numeroDocumento: "" });
  }

  handleSubmit() {
    let data = {
      Accion: "ADD",
      Lista: "TemasCovid19-ConsentimientoInformado",
      UrlSitio: window.location.origin + "/salud/transacciones",
      Campos: {
        Valores: [
          {
            NombreInternoCampo: "TipoDocumento",
            Valor: this.state.documentSelected.CSSiglaText,
          },
          {
            NombreInternoCampo: "NumeroDocumento",
            Valor: this.state.numeroDocumento,
          },
          { NombreInternoCampo: "Nombres", Valor: this.state.nombres },
          { NombreInternoCampo: "Apellidos", Valor: this.state.apellidos },
          { NombreInternoCampo: "Ciudad", Valor: this.state.infoUser.Ciudad },
          {
            NombreInternoCampo: "FechaNacimiento",
            Valor: this.state.fechaNacimiento,
          },
        ],
      },
    };

    isCallService({
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "UtilidadSharepoint",
      params: data,
      changeState: "idUsuario",
      executeCallback: (result) => {
        this.setState({ showModal: false });
        this.descargarCertificado();
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
  }

  getUserData(data) {
    isCallService({
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "ObtenerRiesgosUsuario",
      params: {
        TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
        NumeroDocumento: this.state.numeroDocumento,
        //Opcion: "32",
        TiempoCache: 120,
      },
      changeState: "infoUser",
      executeCallback: (result) => {
        this.setState({
          showModal: true,
          fechaNacimiento: result.FechaNacimiento,
        });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  cleanForm() {
    let newState = {
      showModal: false,
      nombres: "",
      apellidos: "",
      numeroDocumento: "",
      documentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
      },
      ciudad: "",
      fechaNacimiento: "",
      showModal: false,
    };
    this.setState(newState);
  }

  descargarCertificado() {
    // event.preventDefault();
    var fechaNacimiento = moment(this.state.fechaNacimiento, "DD/MM/YYYY");
    let documentSimbol = this.state.documentSelected.CSSiglaText;
    let data = {
      Site: window.location.origin + "/salud/transacciones/",
      TemplateUrl:
        window.location.origin +
        "/salud/transacciones/PlantillasDocWord/ConsentimientoInformado.docx",
      OutputFormat: ".pdf",
      DocumentName: "Consentimiento Informado",
      TemplateBookmarks: [
        { Key: "CIUDAD", Value: "__________" },
        { Key: "DIA", Value: "___" }, //moment().day() },
        { Key: "MES", Value: "___" }, //moment().month() + 1 },
        { Key: "ANIO", Value: "____" }, //moment().format('YYYY') },
        { Key: "HORA", Value: "______" }, //moment(moment()).format("hh:mm a") },
        { Key: "APELLIDOS", Value: this.state.apellidos },
        { Key: "CC", Value: documentSimbol == "CC" ? "X" : "___" },
        { Key: "CE", Value: documentSimbol == "CE" ? "X" : "___" },
        { Key: "RC", Value: documentSimbol == "CRC" ? "X" : "___" },
        { Key: "TI", Value: documentSimbol == "TI" ? "X" : "___" },
        {
          Key: "OTRO",
          Value:
            documentSimbol == "TI" ||
            documentSimbol == "CC" ||
            documentSimbol == "CE" ||
            documentSimbol == "CRC"
              ? "___"
              : documentSimbol,
        },
        //necesita cambios
        {
          Key: "MESNAC",
          Value: moment(this.state.fechaNacimiento, "DD/MM/YYYY").format("MM"),
        },
        {
          Key: "ANIONAC",
          Value: moment(this.state.fechaNacimiento, "DD/MM/YYYY").format(
            "YYYY"
          ),
        },
        {
          Key: "DIANAC",
          Value: moment(this.state.fechaNacimiento, "DD/MM/YYYY").format("DD"),
        },
        {
          Key: "EDAD", //fecha nacimiento
          Value: moment().diff(
            moment(this.state.fechaNacimiento, "DD/MM/YYYY"),
            "years"
          ),
        },
        { Key: "NOMBRES", Value: this.state.nombres },
        { Key: "NUMERO", Value: this.state.numeroDocumento },
        { Key: "RESPONSABLE", Value: "Compensar EPS" },
      ],
    };

    isCallService({
      loadingElement: ".mainLayout_etapa_priorizacion",
      service: "CreateDocument",
      params: data,
      changeState: "file",
      executeCallback: (result) => {
        // this.handleSubmit()
        const isIE =
          window.navigator.userAgent.includes("Trident/7.0") ||
          window.navigator.userAgent.includes("Edge");
        if (!isIE) {
          const file = document.createElement("a");
          file.href = "data:application/pdf;base64," + this.state.file.Base64;
          file.download = this.state.file.DocumentName;
          document.body.appendChild(file);
          file.click();
          document.body.removeChild(file);
        } else {
          const binary = atob(this.state.file.Base64.replace(/\s/g, ""));
          const buffer = new ArrayBuffer(binary.length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < binary.length; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const blob = new Blob([view], { type: "application/pdf;base64" });
          navigator.msSaveBlob(blob, this.state.file.Base64);
        }

        this.cleanForm();
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  handleGenericHtml(data) {
    return { __html: data };
  }

  render() {
    let state = this.state;
    let nombres, apellidos, idNum, idList, ciudad, fechaNacimiento;
    [nombres, apellidos, idNum, idList, ciudad, fechaNacimiento] = [
      state.nombres,
      state.apellidos,
      state.numeroDocumento,
      this.props.documentos,
      state.ciudad,
      state.fechaNacimiento,
    ];
    return (
      <section>
        <Mensajes
          showModal={this.state.error}
          closeModal={() => this.setState({ error: false })}
          MessageTitle={i18next.t("modales.tituloError")}
          Icono={"fa fa-times-circle-o"}
          colorIco={"red"}
          msg={i18next.t("modales.error")}
          AltButtonAction={() => this.setState({ error: false })}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />

        <Mensajes
          showModal={this.state.showModal}
          closeModal={() => this.setState({ showModal: false })}
          MessageTitle={""}
          Icono={"fa fa-info-circle"}
          colorIco={"blue"}
          msg={`Te informamos que de acuerdo al registro se generó el consentimiento informado del usuario ${this.state.nombres} ${this.state.apellidos} ${this.state.documentSelected.CSSiglaText} ${this.state.numeroDocumento} por favor poceda a descargarlo`}
          DescargarButtonAction={() => this.handleSubmit()}
          showDescargaOption={true}
          DescargarButtonText={i18next.t("modales.descargarConsentimiento2")}
          AltButtonAction={() => this.setState({ showModal: false })}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />

        <div
          dangerouslySetInnerHTML={this.handleGenericHtml(
            i18next.t("forms.formConsentimientoSubtitulo")
          )}
        />

        <form
          className="formularioSolicitud noPadding"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="form-group row">
            <div className="col-sm-4">
              <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                Documento de identidad*
              </p>
              <p className="formularioSolicitud--text-aligned">
                {i18next.t("forms.cedulaIndicacion")}
              </p>
            </div>
            <div className="col-sm-3">
              <button
                disabled={false}
                style={{ cursor: "pointer" }}
                className="dropdown-toggle formularioSolicitud--dropDown"
                // type="button"
                id="dropdownCedula"
                // data-toggle="dropdown"
                // aria-haspopup="true"
                // aria-expanded="true"
                onClick={() =>
                  this.setState({
                    visibleSelectorDocumento:
                      !this.state.visibleSelectorDocumento,
                  })
                }
              >
                <div>
                  <p className="text-left">
                    {this.state.documentSelected.CSDocumentoIdentidadText}
                  </p>
                </div>
                <span className="caret"></span>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownCedula"
                  style={{
                    cursor: "pointer",
                    display: `${
                      this.state.visibleSelectorDocumento ? "block " : "none"
                    }`,
                  }}
                >
                  {idList.map((item, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          this.setState({
                            visibleSelectorDocumento: false,
                          });
                          this.updateDocument(item);
                        }}
                      >
                        <p>{item.CSDocumentoIdentidadText}</p>
                      </li>
                    );
                  })}
                </ul>
              </button>
            </div>

            <div className="col-sm-5">
              <input
                style={{ cursor: "pointer" }}
                disabled={false}
                type="text"
                className={
                  idNum == "" || idNum == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={idNum}
                onChange={() => this.handleInput(event)}
                // onBlur={() => props.handleBlur(event)}
                name="NumeroDocumento"
                maxLength={33}
              />
              {idNum == "" || idNum == " " || idNum == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.cedulaError")}
                </p>
              ) : null}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.nombres")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  nombres == "" || nombres == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={nombres}
                onChange={() => this.handleInput(event)}
                // onFocus={() => this.handleInput(event)}
                name="Nombres"
              />
              {nombres == "" || nombres == " " || nombres == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.nombreError")}
                </p>
              ) : null}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.apellidos")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  apellidos == "" || apellidos == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={apellidos}
                onChange={() => this.handleInput(event)}
                // onFocus={() => this.handleInput(event)}
                name="Apellidos"
              />
              {apellidos == "" || apellidos == " " || apellidos == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.apellidosError")}
                </p>
              ) : null}
            </div>
          </div>

          <div className="form-group row hidden">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.fechaNacimiento")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="date"
                className={
                  fechaNacimiento == "" || fechaNacimiento == " "
                    ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                    : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                }
                value={fechaNacimiento}
                onChange={() => this.handleInput(event)}
                // onFocus={() => props.handleInput(event)}
                name="FechaNacimiento"
              />
              {fechaNacimiento == "" ||
              fechaNacimiento == " " ||
              fechaNacimiento == null ? (
                <p className="formularioSolicitud--input-errorLabel">
                  {i18next.t("forms.errorFechaNacimiento")}
                </p>
              ) : null}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 text-center">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => this.getUserData()}
                disabled={
                  idNum == "" ||
                  idNum == " " ||
                  idNum == null ||
                  nombres == "" ||
                  nombres == " " ||
                  nombres == null ||
                  apellidos == "" ||
                  apellidos == " " ||
                  apellidos == null
                    ? //||fechaNacimiento == "" || fechaNacimiento == " " || fechaNacimiento == null
                      true
                    : false
                }
              >
                {i18next.t("forms.buttonGenerarConsentimiento")}
              </button>
            </div>
          </div>
        </form>
      </section>
    );
  }
}
const Button = ReactBootstrap.Button;
